var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "custom-tree-container" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "block",
        },
        [
          _c(
            "div",
            { staticClass: "search" },
            [
              _vm.searchType
                ? _c("span", { on: { click: _vm.searchBack } }, [
                    _vm._v("返回"),
                  ])
                : _vm._e(),
              _c("el-input", {
                attrs: {
                  size: "small",
                  "suffix-icon": "el-icon-search",
                  clearable: "",
                  placeholder: "请输入分类名称",
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.searchFn.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.search,
                  callback: function ($$v) {
                    _vm.search = typeof $$v === "string" ? $$v.trim() : $$v
                  },
                  expression: "search",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "tree" },
            [
              _c(
                "el-scrollbar",
                { staticClass: "ss-scroll" },
                [
                  _c(
                    "el-tree",
                    _vm._b(
                      {
                        ref: "tree",
                        staticStyle: { width: "298px" },
                        attrs: {
                          data: _vm.value,
                          "node-key": "dirId",
                          "default-expanded-keys": _vm.defaultKeys || [-1],
                          "expand-on-click-node": true,
                          props: _vm.defaultProps,
                          "highlight-current": true,
                          "filter-node-method": _vm.filterNode,
                        },
                        on: {
                          "node-click": _vm.nodeClick,
                          "node-expand": _vm.handleExpand,
                          "node-collapse": _vm.handleCollapse,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ node, vdata }) {
                              return _c(
                                "span",
                                { staticClass: "custom-tree-node" },
                                [
                                  node.label.length < 8
                                    ? _c("span", { staticClass: "treeLabel" }, [
                                        _vm._v(_vm._s(node.label)),
                                      ])
                                    : _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            content: node.label,
                                            placement: "bottom-start",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "treeLabel" },
                                            [_vm._v(_vm._s(node.label))]
                                          ),
                                        ]
                                      ),
                                  node.label !== "默认分组"
                                    ? [
                                        !_vm.nobtn
                                          ? _c(
                                              "span",
                                              { staticClass: "label_tree" },
                                              [
                                                _c("el-button", {
                                                  directives: [
                                                    {
                                                      name: "permission",
                                                      rawName: "v-permission",
                                                      value: [
                                                        "system:material:add",
                                                        _vm.permsList,
                                                      ],
                                                      expression:
                                                        "['system:material:add', permsList]",
                                                    },
                                                  ],
                                                  attrs: {
                                                    type: "text",
                                                    icon: "el-icon-circle-plus-outline",
                                                  },
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return (() =>
                                                        _vm.append(
                                                          vdata,
                                                          node
                                                        )).apply(
                                                        null,
                                                        arguments
                                                      )
                                                    },
                                                  },
                                                }),
                                                node.data.id !== "-1" &&
                                                (_vm.permsList.includes(
                                                  "system:material:remove"
                                                ) ||
                                                  _vm.permsList.includes(
                                                    "system:material:edit"
                                                  ) ||
                                                  _vm.permsList.includes(
                                                    "system:material:relationOn"
                                                  ) ||
                                                  _vm.permsList.includes(
                                                    "system:material:relationOff"
                                                  ))
                                                  ? _c(
                                                      "el-dropdown",
                                                      {
                                                        attrs: {
                                                          trigger: "click",
                                                          "hide-on-click": false,
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _c("img", {
                                                            staticClass:
                                                              "scgl-more",
                                                            attrs: {
                                                              src: require("@/assets/image/icon/icon_scgl_more.png"),
                                                            },
                                                          }),
                                                        ]),
                                                        _c(
                                                          "el-dropdown-menu",
                                                          {
                                                            attrs: {
                                                              slot: "dropdown",
                                                            },
                                                            slot: "dropdown",
                                                          },
                                                          [
                                                            _c(
                                                              "el-dropdown-item",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name: "permission",
                                                                    rawName:
                                                                      "v-permission",
                                                                    value: [
                                                                      "system:material:remove",
                                                                      _vm.permsList,
                                                                    ],
                                                                    expression:
                                                                      "['system:material:remove', permsList]",
                                                                  },
                                                                ],
                                                                attrs: {
                                                                  icon: "el-icon-delete",
                                                                },
                                                                nativeOn: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return (() =>
                                                                        _vm.remove(
                                                                          node,
                                                                          vdata
                                                                        )).apply(
                                                                        null,
                                                                        arguments
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [_vm._v("删除")]
                                                            ),
                                                            _c(
                                                              "el-dropdown-item",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name: "permission",
                                                                    rawName:
                                                                      "v-permission",
                                                                    value: [
                                                                      "system:material:edit",
                                                                      _vm.permsList,
                                                                    ],
                                                                    expression:
                                                                      "['system:material:edit', permsList]",
                                                                  },
                                                                ],
                                                                attrs: {
                                                                  icon: "el-icon-edit",
                                                                },
                                                                nativeOn: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return (() =>
                                                                        _vm.update(
                                                                          node,
                                                                          vdata
                                                                        )).apply(
                                                                        null,
                                                                        arguments
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [_vm._v("重命名")]
                                                            ),
                                                            node.data
                                                              .teacherFlag === 2
                                                              ? _c(
                                                                  "el-dropdown-item",
                                                                  {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "permission",
                                                                          rawName:
                                                                            "v-permission",
                                                                          value:
                                                                            [
                                                                              "system:material:relationOn",
                                                                              _vm.permsList,
                                                                            ],
                                                                          expression:
                                                                            "['system:material:relationOn', permsList]",
                                                                        },
                                                                      ],
                                                                    attrs: {
                                                                      icon: "el-icon-star-on",
                                                                    },
                                                                    nativeOn: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return (() =>
                                                                            _vm.relationOn(
                                                                              node
                                                                            )).apply(
                                                                            null,
                                                                            arguments
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "取消关联"
                                                                    ),
                                                                  ]
                                                                )
                                                              : node.data
                                                                  .teacherFlag ===
                                                                0
                                                              ? _c(
                                                                  "el-dropdown-item",
                                                                  {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "permission",
                                                                          rawName:
                                                                            "v-permission",
                                                                          value:
                                                                            [
                                                                              "system:material:relationOff",
                                                                              _vm.permsList,
                                                                            ],
                                                                          expression:
                                                                            "['system:material:relationOff', permsList]",
                                                                        },
                                                                      ],
                                                                    attrs: {
                                                                      icon: "el-icon-star-off",
                                                                    },
                                                                    nativeOn: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return (() =>
                                                                            _vm.relationOff(
                                                                              node
                                                                            )).apply(
                                                                            null,
                                                                            arguments
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "关联"
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            },
                          },
                        ]),
                      },
                      "el-tree",
                      _vm.$attrs,
                      false
                    )
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "AppDialog",
        {
          attrs: { title: _vm.tDialog.title, width: "180", height: "280" },
          on: {
            success: function ($event) {
              _vm.tDialog.visible = false
            },
          },
          model: {
            value: _vm.tDialog.visible,
            callback: function ($$v) {
              _vm.$set(_vm.tDialog, "visible", $$v)
            },
            expression: "tDialog.visible",
          },
        },
        [
          _c(
            "div",
            { staticClass: "info-box" },
            [
              _c("div", { staticClass: "info-title" }, [_vm._v("关联IP")]),
              _c("teacherSelect", {
                ref: "teacherSelect",
                attrs: {
                  value: _vm.select_val,
                  "default-tearch-id": _vm.select_teacherId,
                },
                on: { selected: _vm.onTeacherSelect },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { loading: _vm.data.loading, type: "primary" },
                  on: { click: _vm.submitForm },
                },
                [_vm._v("选择引用")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }